// Suppress false-positive Recharts v3 warning about initial -1 dimensions during container layout phase
const originalWarn = console.warn;
console.warn = (...args) => {
  if (
    args[0] &&
    typeof args[0] === "string" &&
    args[0].includes("The width(-1) and height(-1) of chart should be greater than 0")
  ) {
    return;
  }
  originalWarn(...args);
};
